// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/b__trainingsbolaget.js" defer></script>
console.log('feature')